// extracted by mini-css-extract-plugin
export var stepActive = "_2f-3";
export var stepCompleted = "_2f-4";
export var stepConnectorLine = "_2f-b";
export var stepIndicatorCircle = "_2f-6";
export var stepIndicatorCircleCompleted = "_2f-7";
export var stepIndicatorCircleDefault = "_2f-8";
export var stepIndicatorTextCompleted = "_2f-9";
export var stepIndicatorTextDefault = "_2f-a";
export var stepPending = "_2f-5";
export var wizardContainer = "_2f-1";
export var wizardContent = "_2f-2";
export var wizardModal = "_2f-0";